import React, { useState } from 'react';
import { FaTimes, FaCheck } from 'react-icons/fa';

interface AcceptOfferModalProps {
  isOpen: boolean;
  offerNumber: string;
  onClose: () => void;
  onAccept: (confirmationNote: string) => void;
  loading: boolean;
}

export default function AcceptOfferModal({
  isOpen,
  offerNumber,
  onClose,
  onAccept,
  loading,
}: AcceptOfferModalProps): React.JSX.Element | null {
  const [confirmationNote, setConfirmationNote] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAccept(confirmationNote);
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '12px',
          width: '90%',
          maxWidth: '500px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px 24px',
            borderBottom: '1px solid #e0e3ef',
          }}
        >
          <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#021a4a' }}>
            Angebot akzeptieren
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              color: '#666',
            }}
          >
            <FaTimes size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '24px' }}>
          <div
            style={{
              padding: '12px 16px',
              background: '#d1fae5',
              borderRadius: '8px',
              marginBottom: '20px',
              fontSize: '14px',
              color: '#065f46',
            }}
          >
            <strong>Angebot {offerNumber}</strong> wird als akzeptiert markiert.
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={labelStyle}>
              Kundenbestaetigungsnotiz (optional)
            </label>
            <textarea
              value={confirmationNote}
              onChange={(e) => setConfirmationNote(e.target.value)}
              rows={4}
              placeholder="z.B. Kunde hat per E-Mail am 15.01. bestaetigt..."
              style={{ ...inputStyle, resize: 'vertical' }}
            />
            <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#666' }}>
              Diese Notiz wird intern gespeichert und ist nicht fuer den Kunden sichtbar.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '10px 24px',
                border: '1px solid #e0e3ef',
                borderRadius: '10px',
                background: 'white',
                color: '#666',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 24px',
                border: 'none',
                borderRadius: '10px',
                background: loading ? '#ccc' : '#059669',
                color: 'white',
                fontSize: '14px',
                fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
            >
              <FaCheck size={14} />
              {loading ? 'Wird akzeptiert...' : 'Als akzeptiert markieren'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const labelStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: '6px',
  fontSize: '13px',
  fontWeight: 600,
  color: '#444',
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #e0e3ef',
  borderRadius: '6px',
  fontSize: '14px',
  boxSizing: 'border-box',
};
